import { axiosInstance } from "@/lib/axios";
import { AxiosError } from "axios";
import {
    CategoriesResponse,
    CategoriesTreeResponse,
    CreateCategoryResponse,
    SubCategoriesResponse,
    ProductsResponse
} from "@/types/category.types";

/**
 * 🔹 FETCH CATEGORIES TREE
 */
export const getCategoriesTreeApi = async (): Promise<CategoriesTreeResponse> => {
    const { data } = await axiosInstance.get("/category/tree");
    return data;
};

/**
 * 🔹 CREATE CATEGORY (MULTIPART/FORM-DATA)
 * Restricted to: name, image, description per user request.
 */
export const createCategoryApi = async (
    formData: FormData
): Promise<CreateCategoryResponse> => {
    try {
        const { data } = await axiosInstance.post(`/category`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });

        return data;
    } catch (error) {
        const err = error as AxiosError;
        const responseData = err.response?.data ? JSON.stringify(err.response.data, null, 2) : err.message;
        console.error("DEBUG API ERROR BODY:", responseData);
        throw err;
    }
};

/**
 * 🔹 FETCH PARENT CATEGORIES
 */
export const getParentCategoriesApi = async (page: number, limit: number): Promise<CategoriesResponse> => {
    const { data } = await axiosInstance.get("/category/parent", {
        params: { page, limit, sort: "newest" }
    });
    return data;
};

/**
 * 🔹 FETCH PRODUCTS BY CATEGORY ID
 */
export const getProductsByCategoryIdApi = async (categoryId: string, page: number, limit: number): Promise<ProductsResponse> => {
    const { data } = await axiosInstance.get(`/category/${categoryId}/products`, {
        params: { page, limit, sort: "newest" }
    });
    return data;
};

/**
 * 🔹 FETCH SUB CATEGORIES BY PARENT
 */
export const getSubCategoriesByParentIdApi = async (parentId: string): Promise<SubCategoriesResponse> => {
    const { data } = await axiosInstance.get(`/category/sub/${parentId}`);
    return data;
};

/**
 * 🔹 TOGGLE CATEGORY STATUS
 */
export const toggleCategoryStatusApi = async (
    id: string
): Promise<{ success: boolean; message: string }> => {
    const { data } = await axiosInstance.put(`/category/${id}/toggle`);
    return data;
};

/**
 * 🔹 FETCH PRODUCTS FROM SUB-CATEGORIES
 */
export const getProductsSubCategoryApi = async (parentId: string, page: number, limit: number): Promise<ProductsResponse> => {
    const { data } = await axiosInstance.get(`/category/sub/${parentId}`, {
        params: { page, limit, sort: "newest" }
    });
    return data;
};


/**
 * 🔹 DELETE CATEGORY
 */
export const deleteCategoryApi = async (
    id: string
): Promise<{ success: boolean; message: string }> => {
    const { data } = await axiosInstance.delete(`/category/${id}`);
    return data;
};

/**
 * 🔹 UPDATE CATEGORY (MULTIPART/FORM-DATA)
 */
export const updateCategoryApi = async (
    id: string,
    formData: FormData
): Promise<CreateCategoryResponse> => {
    try {
        const { data } = await axiosInstance.put(`/category/${id}`, formData);

        return data;
    } catch (error) {
        const err = error as AxiosError;
        const responseData = err.response?.data ? JSON.stringify(err.response.data, null, 2) : err.message;
        console.error("DEBUG UPDATE API ERROR:", responseData);
        throw err;
    }
};
/**
 * 🔹 FETCH PRODUCTS BY CATEGORY SLUG
 */
export const getProductsByCategorySlugApi = async (categorySlug: string, page: number, limit: number): Promise<ProductsResponse> => {
    const { data } = await axiosInstance.get(`/category/${categorySlug}/products`, {
        params: { page, limit, sort: "newest" }
    });
    return data;
};
